<template>
  <v-app>
    <component v-bind:is="layout"></component>
  </v-app>
</template>

<script>
import LoginLayout from "./layouts/LoginLayout";
import HomeLayout from "./layouts/HomeLayout";

export default {
  computed: {
    layout() {
      return this.$store.getters.layout;
    }
  },
  components: {
    "home-layout": HomeLayout,
    "login-layout": LoginLayout
  }
};
</script>
